import { render, staticRenderFns } from "./icon-research.vue?vue&type=template&id=99648f02&"
import script from "./icon-research.vue?vue&type=script&lang=ts&"
export * from "./icon-research.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports